import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

export function generatePdf(
  cadastros,
  selectEquipe,
  micro_area,
  dataUltimaSincronizacaoC
) {
  let title_pdf = 'Famílias visitadas'
  let titlePdfSave = utils.methods.titlePdf(
    'Famílias visitadas',
    selectEquipe.no_equipe
  )

  let description_pdf = 'Última visita realizada em algum membro da família'
  let headers_pdf = [
    'RESPONSÁVEL FAMILIAR',
    'NASCIMENTO',
    'IDADE',
    'MA',
    'VISITADO',
    'DIAS',
  ]
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento = utils.methods.formatDate(cadastros[i].dt_nascimento)
    obj.idade = cadastros[i].idade
    obj.micro_area = cadastros[i].micro_area
    obj.dt_ultima_visita = utils.methods.formatDate(
      cadastros[i].dt_ultima_visita
    )
    obj.dias =
      cadastros[i].dt_ultima_visita != null
        ? utils.methods.differenceOfDaysBetweenTwoDates(
            cadastros[i].dt_ultima_visita,
            dataUltimaSincronizacaoC
          )
        : ''
    data_pdf.push(obj)
  }
  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )
      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Microárea',
            value: micro_area,
          },
        ],
        verticalPosition
      )
      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          if (data.row.section !== 'head') {
            if (data.row.raw[4] != undefined) {
              let dt_ultima_visita = data.row.raw[4]
                .split('/')
                .reverse()
                .join('-')
              let dias = data.row.raw[5]
              if (dias > 30 || dt_ultima_visita == undefined) {
                doc.setTextColor(194, 10, 16)
              } else {
                doc.setTextColor(2, 99, 57)
              }
            } else {
              doc.setTextColor(194, 10, 16)
            }
          }

          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export function exibirVermelhos(cadastros, dataUltimaSincronizacaoC) {
  let filtro = cadastros.filter((item) => {
    if (item.dt_ultima_visita !== null) {
      let diff = utils.methods.differenceOfDaysBetweenTwoDates(
        item.dt_ultima_visita,
        dataUltimaSincronizacaoC
      )
      if (diff > 30 || item.dt_ultima_visita == null) {
        return true
      } else {
        return false
      }
    }
    return true
  })
  return filtro
}

export function exibirVerdes(cadastros, dataUltimaSincronizacaoC) {
  let filtro = cadastros.filter((item) => {
    if (item.dt_ultima_visita !== null) {
      let diff = utils.methods.differenceOfDaysBetweenTwoDates(
        item.dt_ultima_visita,
        dataUltimaSincronizacaoC
      )
      if (diff > 30 || item.dt_ultima_visita == null) {
        return false
      } else {
        return true
      }
    }
    return false
  })

  return filtro
}

export const dataFields = {
  'Responsável familiar': 'no_cidadao',
  Nascimento: {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Idade: 'idade',
  MA: 'micro_area',
  Visitado: {
    field: 'dt_ultima_visita',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Dias: {
    field: 'dt_ultima_visita',
    callback: (value) => {
      let dataUltimaSincronizacaoC = ''

      if (store.getters['getSincronizadorC'] !== null) {
        dataUltimaSincronizacaoC = store.getters[
          'getSincronizadorC'
        ].ultimaAtualizacao
          .split('/')
          .reverse()
          .join('-')
      }

      return value !== ''
        ? utils.methods.differenceOfDaysBetweenTwoDates(
            value,
            dataUltimaSincronizacaoC
          )
        : ''
    },
  },
}

export function percentualMunicipio(dadosDaTabelaResultado) {
  let numerador = 0
  let denominador = 0
  let resultado = 0

  let dadosDoMunicipio = dadosDaTabelaResultado
    .filter((item) => {
      return (
        item.nivel == 1 &&
        item.ibge === store.state.cod_ibge &&
        item.indicador == 21
      )
    })
    .sort((a, b) => {
      let [mesA, anoA] = a.mes_ano.split('/').map(Number)
      let [mesB, anoB] = b.mes_ano.split('/').map(Number)

      let dataA = new Date(anoA, mesA - 1)
      let dataB = new Date(anoB, mesB - 1)

      return dataB - dataA // Ordem decrescente
    })[0]

  if (dadosDoMunicipio === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
    }
  }

  let dados = JSON.parse(dadosDoMunicipio.dados)

  numerador = dados.numerador
  denominador = dados.denominador
  resultado = dados.resultado

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
  }
}

export function percentualEquipe(dadosDaTabelaResultado, nuIne) {
  let numerador = 0
  let denominador = 0
  let resultado = 0

  let dadosDaEquipe = dadosDaTabelaResultado
    .filter((item) => {
      return item.nivel == 2 && item.ine === nuIne && item.indicador == 21
    })
    .sort((a, b) => {
      let [mesA, anoA] = a.mes_ano.split('/').map(Number)
      let [mesB, anoB] = b.mes_ano.split('/').map(Number)

      let dataA = new Date(anoA, mesA - 1)
      let dataB = new Date(anoB, mesB - 1)

      return dataB - dataA // Ordem decrescente
    })[0]

  if (dadosDaEquipe === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
    }
  }

  let dados = JSON.parse(dadosDaEquipe.dados)

  numerador = dados.numerador
  denominador = dados.denominador
  resultado = dados.resultado

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
  }
}

export function percentualMicroArea(
  dadosDaTabelaResultado,
  nu_ine,
  micro_area
) {
  let numerador = 0
  let denominador = 0
  let resultado = 0

  let dadosDaMicroArea = dadosDaTabelaResultado
    .filter((item) => {
      return (
        item.nivel == 3 &&
        item.ine == nu_ine &&
        item.micro_area === micro_area &&
        item.indicador == 21
      )
    })
    .sort((a, b) => {
      let [mesA, anoA] = a.mes_ano.split('/').map(Number)
      let [mesB, anoB] = b.mes_ano.split('/').map(Number)

      let dataA = new Date(anoA, mesA - 1)
      let dataB = new Date(anoB, mesB - 1)

      return dataB - dataA // Ordem decrescente
    })[0]

  if (dadosDaMicroArea === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
    }
  }

  let dados = JSON.parse(dadosDaMicroArea.dados)

  numerador = dados.numerador
  denominador = dados.denominador
  resultado = dados.resultado

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
  }
}
